import { isFeatureEnabled } from 'owa-feature-flags';

export function isPrefetchDisabled(): boolean {
    return isFeatureEnabled('fwk-prefetch-data-off');
}
